/**
 * Divider line using design-system border color.
 */

import React from "react";
import Box from "./Box";
import { colors } from "./colors";

export interface DividerProps {
  color?: string;
  sx?: Record<string, unknown>;
}

const Divider: React.FC<DividerProps> = ({ color = colors.border.divider, sx }) => (
  <Box
    component="hr"
    sx={{
      border: "none",
      borderTop: `1px solid ${color}`,
      margin: 0,
      width: "100%",
      ...sx,
    }}
  />
);

export default Divider;
